import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { SuperAdminApp } from './App';
import reportWebVitals from './reportWebVitals';

// Detect if we're on the super admin path
const isSuperAdmin = window.location.hash.startsWith('#/super-admin') || 
                     window.location.pathname.startsWith('/super-admin');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isSuperAdmin ? <SuperAdminApp /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
